<style>
  .alert{
  transition-duration:1s; /* <= creates fade out effect */
  transition-delay:1s;
}
</style>

<template>
    
    <div>
        <div class="notification is-warning" v-if="loading == true">
            Loading your data ....
        </div>

        <div v-if="loading == false && (makeup_area == '' || makeup_area == null)" >
            
            <p>Where are you working today ?</p><br />
            <div class="notification is-warning" v-if="operations.length == 0">
              Loading operations ...
            </div>
            <button class="button is-large is-fullwidth  mb-4" :class="{'is-primary' : row.printing == 1, 'is-info' : row.makeup == 1}" :disabled="loading==true" @click="updateArea(row.name)" v-for="row in operations" :key="row.id">{{ row.label }}</button>
            
            
        </div>

        <div v-if="loading == false && (makeup_input_location_id == '' || makeup_input_location_id == null || makeup_input_location_id == 0)" >
            
            <p>Where are you located ?</p><br />
            <button class="button is-large is-fullwidth is-info" :disabled="loading==true" @click="updateLocation(2)">Giurgiu</button><br />
            
        </div>
        
        <div v-if="loading == false && (makeup_area != '' && order.orderID > 0 && makeup_input_location_id != '')" >
           
              <div class="columns is-mobile" >
                
                <div class="column has-text-centered">
                    <h2 class="title">{{ selectedMakeupArea }} - {{ user.firstname }} {{ user.surname }}</h2>
                    <span class="">PO Number : <strong>{{ order.ponumber }}</strong></span><br />
                    
                    <select class="input is-small" v-model="machine_id" v-if="1==2">
                        <option value="">Select Machine</option>
                        <option v-bind:value="row.id" v-for="row in machines" :key="row.id">{{ row.name }}</option>
                        
                    </select>
                </div>
                
            </div>

            <div >
            
              <div class="columns is-mobile" >
                  <div class="column has-text-right">
                      
                  </div>
                  <div class="column has-text-centered">
                    <button class="button is-small is-success" @click="completeAll()" :disabled="working==true" v-if="this.area_logs.length == 0">Complete All</button>
                    <button v-else class="button is-small button-grey" onClick="alert('You can no longer Complete All as some sizes have already been completed')">Complete All</button>
                  </div>
                  <div class="column">
                      
                  </div>
              </div>

              <div class="" v-for="size in sizesWithQtys" :key="size.id" >
                  <SizeRowOffShore :size="size" :order="order" @submitForm="submitSizeRow($event, size.id)" :working="working" :area="makeup_area"/>
              </div>
            </div>

            <br /><br />
            <button class="button is-large is-fullwidth is-warning" :disabled="loading==true" @click="updateArea('')">Change Operation</button>
            <br />
            <button class="button is-large is-fullwidth is-link" :disabled="loading==true" @click="updateLocation('')">Change Location</button>
            
            <div v-if="area_logs.length > 0">
              <h4 class="title is-5 mt-4">Makeup Log</h4>
              <table class="table is-fullwidth">
                  <thead>
                      <tr>
                          <th>Date/Time</th>
                          <th>User</th>
                          <th>Line</th>
                          <th>Size</th>
                          <th>Qty</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="row in area_logs" :key="row.id">
                          <td>{{ row.date }}</td>
                          <td>{{ row.user_forename }} {{row.user_surname }} </td>
                          <td>{{ row.line_id }}</td>
                          <td>{{ row.size_name }}</td>
                          <td>{{ row.qty }}</td>
                      </tr>
                      
                      </tbody>
              </table>
            </div>
            
        </div>

        

        <div v-if="loading == false && (makeup_area != '' && (order.orderID == 0 || order.orderID == null))" >
            <h2 class="title">{{ selectedMakeupArea }}  - {{ user.firstname }} {{ user.surname }} </h2>
            <p>Search for order</p><br />
            <form @submit.prevent="getOrder()" >
            <input class="input is-large" type="text" placeholder="Enter order number here" v-model="ponumber" ref="makeup_data_input" autocomplete="off"><br /><br />
            <button class="button is-large is-fullwidth is-info" :disabled="loading==true" >Search</button>
            </form>

            <br /><br />
            <button class="button is-large is-fullwidth is-warning" :disabled="loading==true" @click="updateArea('')">Change Area</button>
        </div>
        
    </div>
</template>

<script>
import SizeRowOffShore from '@/components/Makeup/SizeRowOffShore.vue';
import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
 name: 'DataInputMakeup',
  mixins: [OrderMixin],
  components: {SizeRowOffShore},
  data() {
    
    return {
      order: {orderID: 0, makeup_logs: []},
      makeup_area: '',
      loading: false,
      bundle_code: '',
      access_token: '',
      processed:false,
      actions_log : [],
      makeup_input_location_id: '',
      operations: '',
      user: [],
      sizes: [],
      ponumber: ''
      
    }
  },
   methods: {
    async completeAll()
      {
        alert("This button is not yet working. It would complete all sizes in one click.")
      },
      async submitSizeRow(qty, size_id)
      {
        alert("Not yet working");
          this.working = true

          if(this.machine_id == "" || this.machine_id ==0 || this.machine_id == null)
          {
            //alert("Please select the machine you are working on.")
            this.working = false
          }
          else{

            var order_id = this.order.orderID

            var formdata = { 
                qty: qty,
                size_id: size_id,
                order_id: order_id,
                machine_id: this.machine_id
            }; 

            OrderService.printingCuttingInputData(this.accessToken, formdata, this.area)
            .then(() => {
                this.getOrder(true)
                //console.log(response)
            }).catch((error) => {
              alert("Something went wrong and the data has not been saved. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
                this.working = false
            });
           }
      },
    async getOrder(noLoading) {

      if(noLoading == true)
      {
        // Don't show the loading screen
      }
      else{
        this.loading=true
      }

      OrderService.getOrderByPONumber(this.accessToken, this.ponumber, this.makeup_area, 0, 1)
      .then(
        (order => {
          if(order[0] != null)
          {
              this.$set(this, "order", order[0]);
          }
          else if(order.length == 0)
          {
            alert("Order could not be found")
          }
          else{
              console.log(order)
          }
          
          this.loading=false
          this.working = false
        }).bind(this)
      );
      },
      async processBundle()
      {
          this.working = true

         
            
            var formdata = { 
                bundle_code: this.bundle_code,
                area : this.makeup_area,
                location_id : this.makeup_input_location_id
            }; 

            OrderService.bundleInputData(this.accessToken, formdata, this.makeup_area)
            .then(() => {
                //this.getOrder()
                //console.log(response)
                
                this.actions_log.unshift({label : "Bundle " + this.bundle_code + " processed", error: false})

                this.bundle_code = ''
                this.focusInput()

                this.working = false
            }).catch((error) => {
              if(error.response.status == 409)
              {
                this.actions_log.unshift({label : "Error - " + this.bundle_code + " already processed", error : true})
              }
              if(error.response.status == 428)
              {
                this.actions_log.unshift({label : "Error - " + this.bundle_code + " cannot be processed at this operation until earlier operations are completed", error : true})
              }
              else if(error.response.status == 400)
              {
                this.actions_log.unshift({label : "Error - " + this.bundle_code + " not valid", error : true})
              }
              else {
                alert("Something went wrong and the data has not been saved. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
              }
              this.bundle_code = ''
                this.focusInput()
                
                this.working = false
            });
            
            
           
            
           
      },
      updateArea(value) {
        this.loading=true
        this.makeup_area = value
        this.loading = false;

        if(this.makeup_area != '')
        {
            
            this.focusInput()
        }
        
      },
      updateLocation(value) {
        this.loading=true
        this.makeup_input_location_id = value
        this.loading = false;
        

        if(this.makeup_input_location_id != '')
        {
            this.focusInput()
        }
        
      },
      focusInput() {
          this.$nextTick(() => this.$refs.makeup_data_input.focus())
      }
     
   },
   mounted() {
       if (localStorage.makeup_area) {
      this.makeup_area = localStorage.makeup_area;
    }
    else{
      this.makeup_area = ''
    }

    if (localStorage.makeup_input_location_id) {
      this.makeup_input_location_id = localStorage.makeup_input_location_id;
    }
    else{
      this.makeup_input_location_id = ''
    }

    this.focusInput();
    
  },
  computed : {
    sizesWithQtys: function () {  
          let order = this.order
        let sizesWithQtys =  this.sizes.filter(function(u) {
            if( order[u.database_name] > 0 ||  order[u.database_name + '_GK'] > 0) 
            {
               console.log(u)
              return 1
            }
          })

          return sizesWithQtys 
     },
     area_logs: function () {
       let makeup_area = this.makeup_area
       let area_logs =  this.order.makeup_logs.filter(function(u) {
           if(  u.makeup_area == makeup_area) 
           {
              console.log(u)
             return 1
           }
         })

         return area_logs
      
    },
  },
  watch: {
    makeup_area: function () {
     localStorage.makeup_area = this.makeup_area;
      
    },

    makeup_input_location_id: function () {
     localStorage.makeup_input_location_id = this.makeup_input_location_id;
      
    },
    
    
  },
  created() {
     this.getAccessToken()
        .then(() => { 
          this.getUserProfile();
          this.getSizes();
          this.getOperations();
          
        });

        
  },
}
</script>